module.exports = __webpack_public_path__ + "img/40_21.c02e0ed0.png";